import { FormModel } from '../../../../components/Form';
import { Validators } from '../../../../utils/validators';

export const BookingLogsForm = (
  strings: any,
  assigneeList: { value: any, label: any }[],
  followUpModes: { value: any, label: any }[],
): FormModel[] => {
  return [
    {
      label: strings.followUpDate,
      value: '',
      size: 'medium',
      type: 'date',
      variant: 'outlined',
      placeholder: '',
      field: 'followUpDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      minDate: new Date(),
      required: true,
    },
    {
      label: strings.sales_call_follow_up_mode,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'followUpMode',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: followUpModes,
    },
    {
      label: strings.lead_management_contact_details_assignedTo,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'assignedTo',
      validators: [],
      responsive: { xs: 12, sm: 6 },
      options: assigneeList,
      required: false,
    },
    {
      label: strings.remarks,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'textarea',
      variant: 'outlined',
      placeholder: '',
      field: 'remarks',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 6 },
      multiline: true,
      rows: 1,
      required: true,
    },
    {
      label: '',
      value: '',
      type: 'upload',
      placeholder: '',
      field: 'attachment',
      validators: [],
      responsive: { xs: 6 },
      multiline: false,
      required: false,
    },
  ];
};
